/* eslint-disable import/prefer-default-export */
import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { OhsApiRequestName, RequestType } from 'global-services/api/OhsApiModels';
import { ModuleType } from 'global-services/constants/OhsObject';
import { formatSysFieldToCusvalType } from 'global-components/form/sys-fields/sysFieldUtils';

export const fetchMasterRecord = async (_id: string): Promise<any> => {
  const res: any = await OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.MasterFetch,
    {
      forType: ModuleType.Injury,
      _id,
    }
  );
  if (res) {
    return {
      ...res,
      sysfields: (res?.sysfields || []).map((item: any) => ({
        ...item,
        fieldType: formatSysFieldToCusvalType(item.fieldType),
      })),
    };
  }
  return null;
};

// TODO - use a proper listing func, if still needed
export const fetchMasterRecordList = async (): Promise<any> => {
  const res: any = await OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.MasterList,
    {
      forType: 'core.module.injurymgmt',
      filter: {
        viewPreset: 'view_1',
        count: false,
        archived: false,
        categories: [],
        subcategories: [],
        workplaces: [],
        allocatedToOrg: false,
        allocatedToWorkplace: false,
        notAllocated: true,
        workplaceOwned: true,
        sort: {
          order: -1,
          key: '_id',
        },
      },
    }
  );
  return res || null;
};
